// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GoalFocusOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 96 96"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		{...props}
	>
		<defs>
			<path
				d="M70.259 77.26c-7.302 0-13.242-5.94-13.242-13.242 0-7.301 5.94-13.241 13.242-13.241 7.301 0 13.241 5.94 13.241 13.241 0 7.302-5.94 13.242-13.241 13.242m-44.517 0c-7.301 0-13.242-5.94-13.242-13.242 0-7.301 5.941-13.241 13.242-13.241 7.301 0 13.242 5.94 13.242 13.241 0 7.302-5.941 13.242-13.242 13.242m44.517-62.52a2 2 0 0 0 0 4c7.301 0 13.241 5.94 13.241 13.242v21.011c-3.165-3.795-7.925-6.216-13.241-6.216-8.83 0-16.121 6.674-17.116 15.241H42.858c-.996-8.567-8.287-15.241-17.116-15.241-5.317 0-10.077 2.421-13.242 6.216V31.982c0-7.302 5.941-13.242 13.242-13.242a2 2 0 0 0 0-4C16.235 14.74 8.5 22.474 8.5 31.982v32.036c0 9.508 7.735 17.242 17.242 17.242 8.83 0 16.12-6.675 17.116-15.242h10.285c.995 8.567 8.286 15.242 17.116 15.242 9.507 0 17.241-7.734 17.241-17.242V31.982c0-9.508-7.734-17.242-17.241-17.242"
				id="GoalFocusOutline_tsx__a"
			/>
		</defs>
		<use fill="#FFF" xlinkHref="#GoalFocusOutline_tsx__a" fillRule="evenodd" />
	</svg>
);
export default GoalFocusOutline;
